import { render } from "./DatenschutzPage.vue?vue&type=template&id=c7abedc4&scoped=true"
import script from "./DatenschutzPage.vue?vue&type=script&lang=js"
export * from "./DatenschutzPage.vue?vue&type=script&lang=js"

import "./DatenschutzPage.vue?vue&type=style&index=0&id=c7abedc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7abedc4"]])

export default __exports__